'use client'

import OfferUsd from './offer-usd'

import { useSWRConfig } from 'swr'
import InscriptionContent from '@/components/inscription-content'
import styles from './offer-dialog.module.css'
import MakeOfferModal from './make-offer-modal'

/** Shared entry form for quick view and the standalone inscription page. */
export default function ItemOfferModal({
	inscription,
	listedPriceSats,
	floorSats,
	onClose
}: {
	inscription: any
	listedPriceSats?: number | null
	floorSats?: number | null
	onClose: () => void
}) {
	const slug = inscription.collection?.slug
	const { mutate } = useSWRConfig()
	return (
		<MakeOfferModal
			open
			onClose={onClose}
			inscriptionId={inscription.id}
			collectionSlug={slug}
			initialScope="item"
			name={inscription.meta?.name || `Inscription #${inscription.num ?? inscription.id}`}
			reference={{
				listedPriceSats,
				floorSats
			}}
			receiptPreview={<InscriptionContent inscription={inscription} smallCard />}
			itemPreview={
				<div className={styles.itemPreview}>
					<div className={styles.itemImage}>
						<InscriptionContent inscription={inscription} smallCard />
					</div>
					<div className={styles.itemInfo}>
						<h3>{inscription.meta?.name || `Inscription #${inscription.num ?? inscription.id}`}</h3>
						<p>{inscription.collection?.name || 'Bitcoin inscription'}</p>
						<p>
							{listedPriceSats
								? `Listed for ${(listedPriceSats / 1e8).toLocaleString('en-US', {
										maximumFractionDigits: 8
								  })} BTC`
								: listedPriceSats === undefined
								? 'Listing price unavailable'
								: 'Not listed for sale'}
							{listedPriceSats ? <OfferUsd sats={listedPriceSats} /> : null}
						</p>
					</div>
				</div>
			}
			onPlaced={() => {
				if (slug) void mutate(['offers:collection', slug])
			}}
		/>
	)
}
